import GoalCollapse from '../components/goals/GoalCollapse';
import * as React from "react";
import { useState } from "react";
import Flexbox from "flexbox-react";
import { inject, observer, Provider } from "mobx-react";
import { Spinner, NonIdealState } from "@blueprintjs/core";
import { Button, NumericInput, FormGroup, Slider, Card, } from "@blueprintjs/core";
import ThemeWrapper from "../components/styles/ThemeWrapper/index.js";
import LayoutHeader from "../components/layout/LayoutHeader";
import ToastStore from "../stores/ToastStore";
//import CurrentUserStore from "../stores/CurrentUserStore";
import Cookies from "js-cookie";
import ErrorBoundary from "../components/errors/ErrorBoundary";
import { TextArea } from "@blueprintjs/core";
import axios from "axios";
import BlankPage from "../components/goals/BlankPage.js";
import FilledButton from "../components/buttons-20250224T111359Z-001/buttons/FilledButton.jsx";
import TextButton from "../components/buttons-20250224T111359Z-001/buttons/TextButton.jsx";
import DepartmentKPITemplates from "../components/goals/DepartmentKPITemplates.jsx";
import { Alert, Drawer, Tooltip } from "@blueprintjs/core";
import { Icon } from "@blueprintjs/core";
import ScrollableDropdown from "../components/shared/ScrollableDropdown.jsx";
import OutlinedButton from "../components/buttons-20250224T111359Z-001/buttons/OutlinedButton.jsx";
import GoalEditDrawerForm from "../components/goals/GoalEditForm.js";
import FilledButtonWithDropdown from "../components/buttons-20250224T111359Z-001/buttons/ButtonWithDropdown.jsx";
import CurrentUserStore from '../stores/CurrentUserStore.js';
import { Divider } from "@blueprintjs/core";
import "../components/goals/GoalView.css";
import goalIcon from "../assets/GoalIcon.svg";
import { HTMLSelect } from "@blueprintjs/core";
import { Classes } from "@blueprintjs/core";
import moment from "moment";
import { allowedExtensions, goalsMetricConfig } from "../static/Constant.js";

import Progress from "../assets/Progress.svg";
import Weightage from "../assets/Weightage.svg";
import TimeLeft from "../assets/TimeLeft.svg";
import Comment1 from "../assets/Comment1.svg";
import Comment2 from "../assets/Comment2.svg";
import Subgoal from "../assets/Subgoal.svg";
import DescriptionIcon from "../assets/Description.svg";
import CommentIcon from "../assets/CommentIcon.svg";
import EditIcon from "../assets/editIcon.svg";
import Delete from "../assets/Delete.svg"
import ConfirmationDialog from "./ConfirmationDialog.js";
import GoalProgressStatusBadge from "../components/goals/GoalProgressStatusBadge.js";
import GoalProgressRow from "../components/goals/GoalProgressRow.js";
import MilestoneList from "../components/goals/MilestoneList.js";
import CascadingGoalsList from "../components/goals/CascadingGoalsList.js";
import { getGoalListState } from "../utils/goalListUtils.js";
import GoalsHeaderButtonsPanel from "../components/goals/GoalsHeaderButtonsPanel.js";
import {
  getGoalProgressMax,
  getGoalProgressBarValue,
  getMatrixAchievedPercent,
  isGoalProgressSpecialAccount,
  parseProgressPercent,
  clampProgressBarValue,
  formatGoalProgressPercent
} from "../utils/goalProgressUtils.js";
//@inject('ToastStore')
@observer
export default class GoalView extends React.Component {

  initialCascadingGoalState = {
    title: "",
    description: ""
  };
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      isLoading: false,
      selectedTimeframe: {},
      isDropdownOpen: false,
      goalCycleList: [],
      goalList: [],
      userGoalList: [],
      cascadingGoalList: [],
      cascadingSelectionList: [],
      selectedCascadingGoal: null,
      goalStatusList: [],
      cascadeSelection: {
        selected: null,          // Currently selected cascading goal
        pending: null,           // Temporarily selected before confirmation
        showConfirmation: false  // Whether confirmation dialog is open
      },

      editingCascadingGoal: this.initialCascadingGoalState,
      deletingCascadingGoal: null,
      openCascadingGoalEditDrawer: false,
      openCascadingGoalDeleteDialog: false,

      isGoalFormVisible: false,
      editingGoalId: null,
      editingGoal: {},
      isDrawerOpen: false,
      isSavingGoal: false,
      isSavingCascadingGoal: false,
      isCreatingCascadingGoal: false,
      goalWeightAlert: false,
      totalWeight: "",
      selectedEmployeeName: "",
      isSelectedEmployeeAccountOwner: false,
      errorMsg: "",

      openSubGoals: {},
      subGoalsByGoalId: {},
      subGoalLoadingByGoalId: {},
      editingType: null,
      editingSubGoalParent: null,
      showDeleteDialog: false,
      deleteTarget: null,
      isDeleteSubmitting: false

    };
  }

  getStageConfig = (progress, metricValue) => {
    const percent = parseProgressPercent(progress);
    const config = goalsMetricConfig;

    if (metricValue !== undefined && metricValue !== null && config[metricValue]) {
      return config[metricValue];
    }

    if (percent === 100) return config[4];
    if (percent === 50) return config[3];
    return config[0];
  };


  componentDidMount() {
    this._isMounted = true;

    const name = Cookies.get("selectedEmployeeName");
    const isSelectedEmployeeAccountOwner = Cookies.get("selectedEmplyeeAccountOwner");
    if (name) {
      this.setState({
        selectedEmployeeName: name,
        isSelectedEmployeeAccountOwner: isSelectedEmployeeAccountOwner
      });
    }

    this.getAllGoalCycleList();
  }

  componentWillUnmount() {
    this._isMounted = false;
    Cookies.remove("selectedEmployeeId");
    Cookies.remove("selectedEmployeeName");
    Cookies.remove("selectedGoalCycleId");
    Cookies.remove("selectedEmplyeeAccountOwner");
  }

  getMatrixAchieved = (progress) => getMatrixAchievedPercent(progress);

  goalHasSubGoals = (goalId) => {
    const subGoals = this.state.subGoalsByGoalId?.[goalId];
    return Array.isArray(subGoals) && subGoals.length > 0;
  };


  isManagerFlow = () => {
    return Cookies.get("isManagerView") === "true";
  };

  getEffectiveUserId = () => {
    return (
      Cookies.get("selectedEmployeeId") ||
      CurrentUserStore.currentUser.id
    );
  };

  isManagerFlow = () => {
    return Boolean(Cookies.get("selectedEmployeeId"));
  };

  getEmployeeParams = () => {
    const employeeId = Cookies.get("selectedEmployeeId");
    this.setState({ selectedEmployeeName: Cookies.get("selectedEmployeeName") });
    return employeeId ? { employee_id: employeeId, action_by_manager: true } : {};
  };

  handleEditSubGoalOpen = (goal, sub) => {
    const progress_type = this.getActualProgressType(sub);
    const parsedProgress = progress_type === "number"
      ? (sub?.progress_value !== undefined && sub?.progress_value !== null ? Number(sub?.progress_value) : parseProgressPercent(sub?.progress))
      : parseProgressPercent(sub?.progress);

    this.setState({
      editingGoal: {
        id: sub?.id,
        title: sub?.title || "",
        description: sub?.description || "",
        progress: parsedProgress,
        progress_type,
        minValue: sub?.metric_start_range ?? 0,
        maxValue: sub?.metric_end_range ?? 0,
        metric_value: this.getMetricValueInt(sub?.metric_value),
        goal_progress_state_id: sub?.goal_progress_state_id || "",
        user_comment: sub?.user_comment || "",
        goal_setting_id: sub?.goal_setting_id || "",
        file_url: sub?.file_url || null,
        file_name: sub?.file_name || null
      },
      editingType: "subgoal",
      editingSubGoalParent: goal,
      isDrawerOpen: true
    });
  };

  isViewingOtherEmployee = () => {
    const selectedEmployeeId = Cookies.get("selectedEmployeeId");
    return Boolean(selectedEmployeeId);
  };

  getAllGoalCycleList = () => {
    this.setState({ isLoading: true });

    return new Promise((resolve, reject) => {
      axios
        .get(`${Cookies.get("apiEnv")}/goal_settings/goal_cycle_list`)
        .then(response => {
          const goalCycleList = response?.data;

          if (goalCycleList.length > 0) {
            const selectedGoalCycleId = Cookies.get("selectedGoalCycleId");

            let selectedTimeframe = goalCycleList[0];
            if (this.isViewingOtherEmployee() && selectedGoalCycleId) {
              const matchedCycle = goalCycleList.find(gc => String(gc.id) === String(selectedGoalCycleId));
              if (matchedCycle) {
                selectedTimeframe = matchedCycle;
              }
            }

            this.setState(
              {
                goalCycleList,
                selectedTimeframe
              },
              () => {
                this.fetchGoalsForSelectedCycle();
                this.fetchCascadingGoalsForSelectedCycle();
              }
            );
          } else {
            this.setState({ goalCycleList: [], selectedTimeframe: {} });
          }

          this.setState({ isLoading: false });
        })
        .catch(error => {
          this.setState({ error: "Failed to load" });
          ToastStore.showToast("Something went wrong!", "danger");
          this.setState({ isLoading: false });
          reject(error);
        });
    });
  };

  fetchGoalsForSelectedCycle = (showLoading = true) => {
    const { selectedTimeframe } = this.state;

    if (showLoading) this.setState({ isLoading: true });
    const goalsRequest = axios
      .get(`${Cookies.get("apiEnv")}/goal_cascades/all_goals_list`, {
        params: {
          goal_setting_id: selectedTimeframe.id,
          ...this.getEmployeeParams()
        }
      })
      .then(response => {
        const goalState = getGoalListState(response?.data);
        this.setState({ ...goalState, isLoading: false });
        return goalState;
      })
      .catch(error => {
        this.setState({ isLoading: false });
        ToastStore.showToast("Failed to load goals!", "danger");
      });

    if (selectedTimeframe.is_goal_progress_status) {
      axios
        .get(`${Cookies.get("apiEnv")}/goal_progress_states?goal_setting_id=${selectedTimeframe.id}`)
        .then(res => {
          if (Array.isArray(res?.data)) {
            this.setState({ goalStatusList: res?.data });
          }
        })
        .catch(err => {
          this.setState({ goalStatusList: [] });
        });
    }
    return goalsRequest;
  };

  fetchCascadingGoalsForSelectedCycle = () => {
    const { selectedTimeframe } = this.state;
    axios.get(`${Cookies.get("apiEnv")}/goal_cascades`, {
      params: {
        goal_setting_id: selectedTimeframe.id,
      }
    })
      .then(response => {
        const data = response.data;
        this.setState({ cascadingSelectionList: data });
      })
      .catch(error => {
        ToastStore.showToast("Failed to load cascading goals!", "danger");
      });
  };

  handleSelectTimeframe = timeframe => {
    this.setState({ selectedTimeframe: timeframe, isDropdownOpen: false }, () => {
      this.fetchGoalsForSelectedCycle();
      this.fetchCascadingGoalsForSelectedCycle();
    });
  };

  toggleDropdown = () => {
    this.setState(prevState => ({ isDropdownOpen: !prevState.isDropdownOpen }));
  };

  // REFACTORED handleSubmit to follow the prompt instructions.
  handleSubmit = async (id) => {
    try {
      const { editingType, editingGoal, editingSubGoalParent, cascadeSelection } = this.state;
      const selectedCascade = cascadeSelection.selected;

      let payload = {};
      const formData = new FormData();

      const filePreviouslyExisted = !!editingGoal?.file_url;
      const fileNowEmpty = !editingGoal?.file && !editingGoal?.file_name;
      const isRemovingFile = filePreviouslyExisted && fileNowEmpty;
      const isUploadingNewFile = !!editingGoal?.file;

      if (editingType === "subgoal") {
        const metricTypeMap = { percentage: 0, stage_wise: 1, number: 2 };
        const metric_type = metricTypeMap[editingGoal.progress_type || "percentage"] ?? 0;

        payload = {
          title: editingGoal?.title,
          description: editingGoal?.description,
          ...(metric_type === 2 ? { progress_value: editingGoal?.progress } : { progress: editingGoal?.progress }),
          user_id: this.getEffectiveUserId(),
          goal_setting_id: this.state.selectedTimeframe.id,
          goal_id: editingSubGoalParent.id,
          sub_goal_id: id,
          metric_type,
          ...(metric_type === 1 && { metric_value: editingGoal?.metric_value ?? 0 }),
          ...(metric_type === 2 && { metric_start_range: editingGoal?.minValue ?? 0, metric_end_range: editingGoal?.maxValue ?? 0 }),
          ...(isRemovingFile && { file: null, remove_file: true })
        };
      } else {
        const hasSubGoals = this.goalHasSubGoals(editingGoal?.id);
        const metricTypeMap = { percentage: 0, stage_wise: 1, number: 2 };
        const metric_type = metricTypeMap[editingGoal?.progress_type || "percentage"] ?? 0;

        const basePayload = {
          title: editingGoal?.title,
          description: editingGoal?.description,
          goal_weight: editingGoal?.goal_weight,
          goal_end_at: editingGoal?.goal_end_at,
          goal_progress_state_id: editingGoal?.goal_progress_state_id,
          user_comment: editingGoal?.user_comment,
          goal_setting_id: editingGoal?.goal_setting_id,
          goal_id: id,
          ...(isRemovingFile && { file: null, remove_file: true }),
          ...(selectedCascade && { goal_cascade_id: selectedCascade.id })
        };

        if (hasSubGoals) {
          payload = basePayload;
        } else {
          payload = {
            ...basePayload,
            ...(metric_type === 2 ? { progress_value: editingGoal?.progress } : { progress: editingGoal?.progress }),
            metric_type,
            ...(metric_type === 1 && { metric_value: editingGoal?.metric_value ?? 0 }),
            ...(metric_type === 2 && { metric_start_range: editingGoal?.minValue ?? 0, metric_end_range: editingGoal?.maxValue ?? 0 })
          };
        }
      }

      formData.append("payload", JSON.stringify(payload));

      const fileKey = `files[${id}]`;
      if (isUploadingNewFile) {
        formData.append(fileKey, editingGoal.file);
      }

      this.setState({ isSavingGoal: true });

      const url = editingType === "subgoal"
        ? `${Cookies.get("apiEnv")}/sub_goals/${id}`
        : `${Cookies.get("apiEnv")}/goals/${id}`;

      const res = await axios.put(url, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      // Reload authoritative goal and sub-goal progress without collapsing the list.
      await this.fetchGoalsForSelectedCycle(false);
      this.setState({
        isSavingGoal: false,
        editingGoal: null,
        editingType: null,
        editingSubGoalParent: null,
        isDrawerOpen: false,
        cascadeSelection: { selected: null, pending: null, showConfirmation: false }
      });

      ToastStore.showToast(
        res?.data?.message ||
        (editingType === "subgoal"
          ? "Sub goal updated successfully"
          : "Goal updated successfully"),
        "success"
      );
    } catch (err) {
      const errorMessage = err?.response?.data?.message || err?.response?.data?.error || "Update failed";
      ToastStore.showToast(errorMessage, "danger");
      this.setState({ isSavingGoal: false });
    }
  };

  handleSubmitCascadingGoal = async () => {
    try {
      this.setState({ isSavingCascadingGoal: true });
  
      const { editingCascadingGoal, selectedTimeframe } = this.state;
      const { id } = editingCascadingGoal;
  
      const payload = {
        title: editingCascadingGoal.title,
        description: editingCascadingGoal.description,
        goal_setting_id: selectedTimeframe.id
      };
  
      const res = await axios.put(
        `${Cookies.get("apiEnv")}/goal_cascades/update/${id}`,
        payload
      );
  
      ToastStore.showToast(
        res?.data?.message || "Cascading goal updated successfully",
        "success"
      );
  
      // Reset drawer first
      this.setState({
        isSavingCascadingGoal: false,
        editingCascadingGoal: this.initialCascadingGoalState,
        openCascadingGoalEditDrawer: false
      });
  
      // Fetch fresh data from backend
      await Promise.all([
        this.fetchGoalsForSelectedCycle(),
        this.fetchCascadingGoalsForSelectedCycle()
      ]);
  
    } catch (err) {
      console.error("Failed to update cascading goal", err);
  
      ToastStore.showToast(
        err?.response?.data?.message || "Update cascading goal failed",
        "danger"
      );
  
      this.setState({ isSavingCascadingGoal: false });
    }
  };

  handleEditCascadingGoal = cascade => {
    this.setState({
      editingCascadingGoal: cascade,
      openCascadingGoalEditDrawer: true
    });
  };

  handleCascadeFieldChange = (field, value) => {
    this.setState(prev => ({
      editingCascadingGoal: {
        ...prev.editingCascadingGoal,
        [field]: value
      }
    }));
  };

  handleDeleteCascadingGoal = cascade => {
    this.setState({
      deletingCascadingGoal: cascade,
      openCascadingGoalDeleteDialog: true
    });
  };

  handleCancelCascadingGoal = () => {
    this.setState({
      editingCascadingGoal: this.initialCascadingGoalState,
      openCascadingGoalEditDrawer: false
    });
  };

  handleCascadeSelection = cascade => {
    const { editingGoal } = this.state;

    if (this.goalHasSubGoals(editingGoal.id)) {
      this.setState(prev => ({
        cascadeSelection: {
          ...prev.cascadeSelection,
          pending: cascade,
          showConfirmation: true
        }
      }));
      return;
    }
    this.setState(prev => ({
      cascadeSelection: {
        ...prev.cascadeSelection,
        selected: cascade
      },
      editingGoal: {
        ...editingGoal,
        cascade_id: cascade.id
      }
    }));
  };


  handleConfirmCascadeSelection = () => {
    this.setState(prev => ({
      cascadeSelection: {
        selected: prev.cascadeSelection.pending,
        pending: null,
        showConfirmation: false
      }
    }));
  };

  handleCancelCascadeSelection = () => {
    this.setState(prev => ({
      cascadeSelection: {
        ...prev.cascadeSelection,
        pending: null,
        showConfirmation: false
      }
    }));
  };

  handleCloseDeleteCascadingGoalConfirmationDialog = () => {
    this.setState({
      openCascadingGoalDeleteDialog: false,
      deletingCascadingGoal: null
    });
  };

  handleConfirmDeleteCascadingGoal = () => {
    const { deletingCascadingGoal, selectedTimeframe } = this.state;
    const employeeId = Cookies.get("selectedEmployeeId") || CurrentUserStore.currentUser.id;
    axios.delete(`${Cookies.get("apiEnv")}/goal_cascades/${deletingCascadingGoal.id}`, {
      data: {
        employee_id: employeeId,
        goal_setting_id: selectedTimeframe.id
      }
    })
      .then(response => {
        ToastStore.showToast("Cascading goal deleted successfully", "success");
        this.fetchGoalsForSelectedCycle();
        this.fetchCascadingGoalsForSelectedCycle();
        this.setState({
          openCascadingGoalDeleteDialog: false,
          deletingCascadingGoal: null
        });
      })
      .catch(error => {
        ToastStore.showToast("Failed to delete cascading goal", "danger");
      });
  };

  handleEditGoal = goal => {
    const progress_type = this.getActualProgressType(goal);
    const selectedCascade = this.state.cascadingSelectionList.find(
      cascade => cascade.id === goal.cascading_id
    );
    const displayProgress = progress_type === "number"
      ? (goal.progress_value !== undefined && goal.progress_value !== null ? Number(goal.progress_value) : parseProgressPercent(goal.progress))
      : parseProgressPercent(goal.progress);

    this.setState({
      editingGoal: {
        ...goal,
        progress: displayProgress,
        progress_type,
        minValue: goal?.metric_start_range ?? 0,
        maxValue: goal?.metric_end_range ?? 0,
        metric_value: this.getMetricValueInt(goal?.metric_value)
      },
      cascadeSelection: {
        selected: selectedCascade || null,
        pending: null,
        showConfirmation: false
      },
      editingType: "goal",
      isDrawerOpen: true
    });
  };

  handleCancelGoal = () => {
    this.setState({
      editingGoal: null,
      isDrawerOpen: false, 
      cascadeSelection: {
        selected: null,
        pending: null,
        showConfirmation: false
      }
    });
  };

  handleSendForApproval = () => {
    const { selectedTimeframe } = this.state;
    this.setState({ isLoading: true });
    axios
      .get(`${Cookies.get("apiEnv")}/goals/send_for_approval`, {
        params: {
          goal_setting_id: selectedTimeframe.id
        }
      })
      .then(response => {
        this.setState({ isLoading: false });
        this.fetchGoalsForSelectedCycle();
        const msg = response?.data?.message || "Goals Sent for Approval!";
        ToastStore.showToast(msg, "success");
      })
      .catch(error => {
        this.setState({ isLoading: false });
        const errors = error.response?.data?.message;
        ToastStore.showToast(errors, "danger");
      });
  };

  openDeleteGoalConfirmationDialog = (goal) => {
    this.setState({
      showDeleteDialog: true,
      deleteTarget: {
        type: "goal",
        goal
      }
    });
  };

  openDeleteSubGoalConfirmationDialog = (goal, sub) => {
    this.setState({
      showDeleteDialog: true,
      deleteTarget: { type: "subgoal", goal, sub }
    });
  };

  handleConfirmDelete = async () => {
    try {
      const { deleteTarget } = this.state;
      this.setState({ isDeleteSubmitting: true });
      if (deleteTarget.type === "subgoal") {

        await axios.delete(
          `${Cookies.get("apiEnv")}/sub_goals/${deleteTarget.sub.id}`,
          {
            data: {
              user_id: this.getEffectiveUserId(),
              goal_setting_id: this.state.selectedTimeframe.id,
              goal_id: deleteTarget.goal.id
            }
          }
        );

      } else {
        await axios.delete(
          `${Cookies.get("apiEnv")}/goals/${deleteTarget.goal.id}`,
          {
            data: {
              goal_setting_id: this.state.selectedTimeframe.id
            }
          }
        );
      }

      await this.fetchGoalsForSelectedCycle();

      this.setState({
        showDeleteDialog: false,
        deleteTarget: null,
        isDeleteSubmitting: false
      });

    } catch (err) {
      ToastStore.showToast("Delete failed", "danger");
      this.setState({ isDeleteSubmitting: false });
    }
  };

  handleAddGoalClick = () => {
    const { selectedTimeframe } = this.state;
    this.setState({ isLoading: true });
    axios
      .post(`${Cookies.get("apiEnv")}/goals`, {
        goal_setting_id: selectedTimeframe.id,
        ...this.getEmployeeParams()
      })
      .then(response => {
        this.setState({ isLoading: false });
        this.fetchGoalsForSelectedCycle();
      })
      .catch(error => {
        ToastStore.showToast("Failed to create goal!", "danger");
        this.setState({ isLoading: false });
      });
  };

  handleAddCascadingGoalClick = () => {
    const { selectedTimeframe } = this.state;
    const payload = {
      goal_setting_id: selectedTimeframe.id,
      ...this.getEmployeeParams()
    };

    this.setState({ isCreatingCascadingGoal: true });

    axios.post(`${Cookies.get("apiEnv")}/goal_cascades/create`, payload)
      .then(response => {
        const data = response?.data || {};

        let createdCascade = null;
        if (data.goal_cascade && typeof data?.goal_cascade === 'object') {
          createdCascade = data?.goal_cascade;
        } else if (data?.id || data?.title) {
          createdCascade = data;
        } else {
          createdCascade = {
            ...payload,
            id: Date.now(),
            title: data?.title || "New Cascading Goal",
            description: data?.description || "",
            progress_percentage: data?.progress_percentage || 0,
            created_by: data?.created_by || this.getEffectiveUserId()
          };
        }

        this.setState(prev => ({
          cascadingGoalList: [createdCascade, ...prev.cascadingGoalList],
          cascadingSelectionList: [createdCascade, ...prev.cascadingSelectionList],
          isCreatingCascadingGoal: false
        }));

        Promise.all([
          this.fetchGoalsForSelectedCycle(),
          this.fetchCascadingGoalsForSelectedCycle()
        ]).catch(() => {});

        ToastStore.showToast("Cascading goal created successfully!", "success");
      })
      .catch(error => {
        this.setState({ isCreatingCascadingGoal: false });
        const message = error?.response?.data?.message || error?.response?.data?.error || "Failed to create cascading goal!";
        ToastStore.showToast(message, "danger");
      });

  };

  handleSelectDepartmentTemplate = (department) => {
    const { selectedTimeframe } = this.state;
    if (!selectedTimeframe.id) {
      ToastStore.showToast("Please select a goal cycle first", "warning");
      return;
    }
    this.setState({ isLoading: true });
    const payload = {
      goal_setting_id: selectedTimeframe.id,
      template_key: department.id,
      user_id: this.getEffectiveUserId()
    };

    axios
      .post(`${Cookies.get("apiEnv")}/goals/goal_templates/apply`, payload)
      .then(() => {
        ToastStore.showToast(`${department.name} KPI goals added successfully!`, "success");
        this.fetchGoalsForSelectedCycle();
      })
      .catch(error => {
        ToastStore.showToast("Failed to add template goals. Please try again.", "danger");
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };


  handleAddSubGoal = goal => {
    const { selectedTimeframe } = this.state;
    if (!selectedTimeframe.id || !goal?.id) {
      ToastStore.showToast("Missing goal info to add sub-goal", "danger");
      return;
    }
    const payload = {
      goal_setting_id: selectedTimeframe.id,
      goal_id: goal.id,
      user_id: this.getEffectiveUserId(),
      ...(this.isManagerFlow() && { action_by_manager: true })
    };

    if (this._isMounted) {
      this.setState(prev => ({
        subGoalLoadingByGoalId: {
          ...prev.subGoalLoadingByGoalId,
          [goal.id]: true
        }
      }));
    }

    axios
      .post(`${Cookies.get("apiEnv")}/sub_goals`, payload)
      .then(async response => {
        const message = response?.data?.message || "Sub Goal created successfully";
        ToastStore.showToast(message, "success");

        const refreshed = await this.fetchGoalsForSelectedCycle(false);
        if (!refreshed) throw new Error("Failed to refresh goals");
        if (this._isMounted) {
          this.setState(prev => ({
            openSubGoals: { ...prev.openSubGoals, [goal.id]: true },
            subGoalLoadingByGoalId: {
              ...prev.subGoalLoadingByGoalId,
              [goal.id]: false
            }
          }));
        }
      })
      .catch(error => {
        // const message = error?.response?.data?.message || error?.response?.data?.error || "Failed to load sub-goal";
        if (this._isMounted) {
          this.setState(prev => ({
            subGoalLoadingByGoalId: {
              ...prev.subGoalLoadingByGoalId,
              [goal.id]: false
            }
          }));
        }
      });
  };
  getActiveAccountId = () => CurrentUserStore?.activeAccount?.accountId ?? null;

  isSpecialAccount = () => isGoalProgressSpecialAccount(this.getActiveAccountId());

  getProgressMax = () => getGoalProgressMax(this.getActiveAccountId());

  handleCloseDeleteDialog = () => {
    if (this.state.isDeleteSubmitting) return;

    this.setState({
      showDeleteDialog: false,
      deleteTarget: null
    });
  };

  handleEditSubGoal = async (goal, sub, payload) => {
    try {
      const userId =
        Cookies.get("selectedEmployeeId") ||
        CurrentUserStore.currentUser.id;

      const res = await axios.put(
        `${Cookies.get("apiEnv")}/sub_goals/${sub.id}`,
        {
          ...payload,
          user_id: userId,
          goal_setting_id: this.state.selectedTimeframe.id,
          goal_id: goal.id
        }
      );

      await this.fetchGoalsForSelectedCycle(false);

      ToastStore.showToast("Sub goal updated successfully", "success");
    } catch (err) {
      const errorMessage = err?.response?.data?.message || err?.response?.data?.error || "Failed to update sub goal";
      ToastStore.showToast(errorMessage, "danger");
    }
  };

  handleFileUpload = (goalId, file) => {
    if (!file) return;

    const MAX_SIZE = 15 * 1024 * 1024;
    const extension = file.name.split(".").pop().toLowerCase();

    if (file.size > MAX_SIZE || !allowedExtensions.includes(extension)) {
      ToastStore.showToast("File size should not exceed 10MB and allowed file are PDF, Word, Document, Excel, Image, PowerPoint", "danger");
      return;
    }

    this.setState(prev => ({
      editingGoal: {
        ...prev.editingGoal,
        file: file,
        file_name: file.name
      }
    }));
  };

  handleGoalInputChange = (goalId, name, value) => {
    const { selectedTimeframe } = this.state;

    this.setState(prevState => {
      const updatedValue = name === "goal_weight" ? parseFloat(value) || 0 : value;
      let updatedEditingGoal = {
        ...prevState.editingGoal,
        [name]: updatedValue
      };

      if (name === "goal_end_at") {
        const cycleStart = moment(selectedTimeframe.start_time);
        const cycleEnd = moment(selectedTimeframe.end_time);
        const newEndDate = moment(value);
        if (newEndDate.isBefore(cycleStart)) {
          ToastStore.showToast(
            `Goal end date cannot be before the cycle start date (${cycleStart.format("DD MMM YYYY")}).`,
            "danger"
          );
          updatedEditingGoal.goal_end_at = prevState.editingGoal.goal_end_at || "";
        }
        else if (newEndDate.isAfter(cycleEnd)) {
          ToastStore.showToast(
            `Goal end date cannot be after the cycle end date (${cycleEnd.format("DD MMM YYYY")}).`,
            "danger"
          );
          updatedEditingGoal.goal_end_at = prevState.editingGoal.goal_end_at || "";
        }
      }
      const allGoals = prevState.userGoalList.map(goal =>
        goal.id === updatedEditingGoal.id ? updatedEditingGoal : goal
      );
      const totalWeight = allGoals.reduce(
        (sum, g) => sum + (parseFloat(g.goal_weight || g.weight || 0) || 0),
        0
      );
      return {
        editingGoal: updatedEditingGoal,
        totalWeight
      };
    });
  };

  getSelectedStatusLabel = () => {
    const { goalStatusList, editingGoal } = this.state;

    const selectedStatus = goalStatusList.find(s => s.id === editingGoal.goal_progress_state_id);

    return selectedStatus ? selectedStatus.status_name : "";
  };

  getStatusColor = value => {
    if (value === "Draft") return "#707070";
    else if (value === "Approved") return "#10A423";
    else if (value === "Rejected") return "#db3737";
    else if (value === "Pending") return "#D99B00";
    else return "#707070";
  };

  getDaysLeft = (goal) => {
    if (!goal.goal_end_at) return "";

    const today = moment();
    const endDate = moment(goal.goal_end_at);
    const diff = endDate.diff(today, "days");

    if (diff < 0) return "Expired";
    if (diff === 0) return "Ends today";

    return `${diff} days left`;
  };

  getActualProgressType = (goal) => {
    if (goal.metric_type === 1 || goal.metric_type === "stage") return "stage_wise";
    if (goal.metric_type === 2 || goal.metric_type === "number") return "number";
    if (goal.metric_type === 0 || goal.metric_type === "percentage") return "percentage";
    return goal.progress_type || this.getProgressType(goal.progress);
  };

  getMetricValueInt = (value) => {
    if (value === undefined || value === null) return 0;
    const map = {
      0: 0,
      1: 1,
      2: 2,
      3: 3,
      4: 4,
      "not_started": 0,
      "on_hold": 1,
      "not_completed": 2,
      "in_progress": 3,
      "completed": 4
    };
    return map[value] ?? 0;
  };

  getProgressType = (progress) => {
    const percent = parseProgressPercent(progress);
    if ([0, 10, 50, 100, 90].includes(percent)) return "stage_wise";
    if (percent % 10 === 0 && percent <= 100 && percent >= 0) return "number";
    return "percentage";
  };

  getStageName = (progress, metricValue) => {
    const percent = parseProgressPercent(progress);
    if (metricValue !== undefined && metricValue !== null) {
      const stageMap = {
        0: "Not Started",
        1: "On Hold",
        2: "Not Completed",
        3: "In Progress",
        4: "Completed",
        "not_started": "Not Started",
        "on_hold": "On Hold",
        "not_completed": "Not Completed",
        "in_progress": "In Progress",
        "completed": "Completed"
      };
      if (stageMap[metricValue]) return stageMap[metricValue];
    }

    if (percent === 100) return "Completed";
    if (percent === 50) return "In Progress";
    return "Not Started";
  };

  getDescriptionPreview = (description) => {
    if (!description) return "";
    const maxChars = 120;
    if (description.length <= maxChars) return description;
    return `${description.slice(0, maxChars)}... Read more`;
  };

  handleBack = () => {
    if (window?.history?.length > 1) {
      window.history.back();
    } else {
      Utilities.navigate("/goals/peer");
    }
  };

  render() {
    const stores = {
      // CurrentUserStore,
      ToastStore
    };
    const {
      selectedTimeframe,
      isDropdownOpen,
      goalCycleList,
      cascadingGoalList,
      cascadingSelectionList,
      selectedCascadingGoal,
      cascadeSelection,
      editingCascadingGoal,
      deletingCascadingGoal,
      openCascadingGoalEditDrawer,
      openCascadingGoalDeleteDialog,
      goalList,
      userGoalList,
      isLoading,
      isSavingGoal,
      isSavingCascadingGoal,
      isCreatingCascadingGoal,
      subGoalLoadingByGoalId,
      selectedEmployeeName,
      isSelectedEmployeeAccountOwner,
      totalWeight,
      editingGoalId,
      goalStatusList,
      editingGoal,
      editingType,
      isDrawerOpen
    } = this.state;
    const isAccountOwner = CurrentUserStore?.activeAccount?.accountOwner;
    const isGoalEditing = this.state.editingType === "goal";
    const hasSubGoals = isGoalEditing
      ? this.goalHasSubGoals(this.state.editingGoal?.id)
      : false;
    const currentPageEmployeeId = Cookies.get("selectedEmployeeId") || CurrentUserStore.currentUser.id;

    const filteredGoalCycles = goalCycleList.filter(gc => gc.id !== selectedTimeframe.id);
    if (isLoading) {
      return (
        <Flexbox flexGrow={1} flexDirection="column" justifyContent="center" alignItems="center" style={{ minHeight: "300px" }}>
          <img
            style={{ height: "35px", width: "35px" }}
            src="https://s01.live2support.com/dashboardv2/chatassets/img/loader_new.gif"
            alt="Loading..."
          />
        </Flexbox>
      );
    }
    return (
      <Provider {...stores}>
        <ThemeWrapper>
          <ErrorBoundary>
            <Flexbox flexGrow={1} width="100hw" alignContent="stretch" flexDirection="column" className="push-20-l push-20-r">
              <Flexbox flexDirection="column">
                <div style={{ display: "flex", marginTop: 15 }}>
                  {this.isManagerFlow() && (
                    <Icon
                      icon="arrow-left"
                      onClick={this.handleBack}
                      className="arrow-icon"
                      style={{ cursor: "pointer", marginRight: 11, marginTop: 13 }}
                    />
                  )}
                  <p className="" style={{ fontSize: "26px", fontWeight: "600", color: "#2e2e2e" }}>
                    {this.isViewingOtherEmployee() ? `Smart Goals for ${selectedEmployeeName}` : `My Smart Goals`}
                  </p>
                </div>
                <p className="" style={{ fontSize: "14px", fontWeight: "400", color: "#707070", lineHeight: "normal" }}>
                  Set, track, and achieve your professional goals. Learn more.
                </p>
              </Flexbox>

              <GoalsHeaderButtonsPanel
                selectedTimeframe={selectedTimeframe}
                filteredGoalCycles={filteredGoalCycles}
                isAccountOwner={isAccountOwner}
                isSelectedEmployeeAccountOwner={isSelectedEmployeeAccountOwner}
                userGoalList={userGoalList}
                handleDefaultAction={this.handleDefaultAction}
                isViewingOtherEmployee={this.isViewingOtherEmployee}
                handleSelectTimeframe={this.handleSelectTimeframe}
                handleSelectDepartmentTemplate={this.handleSelectDepartmentTemplate}
                handleAddGoalClick={this.handleAddGoalClick}
                handleAddCascadingGoalClick={this.handleAddCascadingGoalClick}
                handleSendForApproval={this.handleSendForApproval}
                isManagerFlow={this.isManagerFlow()}
              //  canCreateCascadingGoal={canCreateCascadingGoal}
              />

              <Flexbox flexGrow={1} flexDirection="column" alignItems="flex-end" justifyContent="flex-end" className="push-20-t ">
                {userGoalList.length > 0 && <div style={{ fontSize: "14px" }}>Total Weightage: {totalWeight}</div>}
                {userGoalList.length > 0 && <span style={{ color: "red", fontSize: "14px", visibility: (totalWeight > 100 || totalWeight < 100) ? "visible" : "hidden" }}>
                  ⚠️ Total Weightage should be 100 for correct calculation.
                </span>}
              </Flexbox>

              <Flexbox flexDirection="column">
                <div>
                  {cascadingGoalList && cascadingGoalList.length > 0 && (
                    <>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "16px", fontWeight: "600", color: "#2e2e2e", marginBottom: "10px" }}>

                        <span> Cascading Goals</span>

                        <Tooltip
                          portalContainer={document.body}
                          content={
                            <div style={{ maxWidth: "300px", lineHeight: "1.5" }}>
                              <div style={{ marginTop: "4px" }}>
                                Break down a larger goal into smaller goals for teams or individuals. Linked goals contribute to the overall parent goal.
                              </div>
                            </div>
                          }
                          placement="top"
                          hoverOpenDelay={100}
                          boundary="viewport"
                          className="custom-bp-tooltip"
                        >
                          <Icon icon="help" size={14} color="#64748B" style={{ marginBottom: "2px" }} />
                        </Tooltip>
                      </div>
                      <CascadingGoalsList
                        cascadingGoalList={cascadingGoalList}
                        selectedTimeframe={selectedTimeframe}
                        getStatusColor={this.getStatusColor}
                        getDaysLeft={this.getDaysLeft}
                        getActiveAccountId={this.getActiveAccountId}
                        handleEditCascadingGoal={this.handleEditCascadingGoal}
                        handleDeleteCascadingGoal={this.handleDeleteCascadingGoal}
                        handleEditGoal={this.handleEditGoal}
                        handleDeleteGoal={this.openDeleteGoalConfirmationDialog}
                        onViewGoal={this.handleViewGoal}
                        onGoalLinked={() => this.fetchGoalsForSelectedCycle(false)}
                        isManagerFlow={this.isManagerFlow()}
                        onUpdateProgress={this.handleUpdateProgress}
                        initiatedBy={'goal'}
                        currentPageEmployeeId={currentPageEmployeeId}
                      />
                    </>
                  )}


                  {goalList && goalList.length > 0 ? (
                    <>
                      <div style={{ fontSize: "16px", fontWeight: "600", color: "#2e2e2e", marginBottom: "10px" }}>Goals</div>
                      {goalList.map(goal => {
                        const goalProgressType = this.getActualProgressType(goal);
                        const goalProgress = parseProgressPercent(goal.progress);
                        const subGoals =
                          (this.state.subGoalsByGoalId && this.state.subGoalsByGoalId[goal.id]) ||
                          goal.subgoals ||
                          goal.sub_goals ||
                          [];
                        return (
                          <Card key={goal.id} className="goal-card">
                            <Flexbox
                              flexDirection="row"
                            >
                              <Flexbox flexDirection="column">
                                <div className="goal-icon-box" role="img" aria-label="goal-icon">
                                  <img src={goalIcon} alt={"goalIcon"}></img>
                                </div>
                              </Flexbox>

                              {/* Left Section: Title + Description */}
                              <Flexbox flexDirection="column" style={{ flex: 1, paddingLeft: "12px" }}>

                                <Flexbox alignItems="center" gap="8px" style={{ marginBottom: 8 }}>
                                  <span onClick={() => this.handleEditGoal(goal)} className="goal-title">
                                    {goal.title}
                                  </span>
                                  {goal.user_comment && (
                                    <Tooltip portalContainer={document.body} content={goal.user_comment} placement="top" popoverClassName="goal-description-tooltip">
                                      <div style={{ cursor: "pointer", marginTop: '5px' }}>
                                        <img
                                          src={Comment1}
                                          alt="comment icon"
                                          style={{ width: 20, height: 20, marginRight: '5px' }}
                                        />
                                      </div>
                                    </Tooltip>
                                  )}
                                  {goal.goal_comment && (
                                    <Tooltip portalContainer={document.body} content={goal.goal_comment} placement="top" popoverClassName="goal-description-tooltip">
                                      <div style={{ cursor: "pointer", marginTop: '5px' }}>
                                        <img
                                          src={Comment2}
                                          alt="comment icon"
                                          style={{ width: 20, height: 20, marginRight: '5px' }}
                                        />
                                      </div>
                                    </Tooltip>
                                  )}
                                  {/* {goal.description && ( */}
                                  <Tooltip portalContainer={document.body} content={goal.description} placement="top" popoverClassName="goal-description-tooltip">
                                    <div style={{ cursor: "pointer", marginTop: '5px' }}>
                                      <img
                                        src={DescriptionIcon}
                                        alt="description icon"
                                        style={{ width: 20, height: 20, marginRight: '5px' }}
                                      />
                                    </div>
                                  </Tooltip>
                                  {/* )} */}
                                </Flexbox>
                                {/* Description under title removed as per request */}

                                <Flexbox flexDirection="row" gap="16px" className="weitage-progres-row" alignItems="center">
                                  <Flexbox flexDirection="row" display="flex" alignItems="center" gap="8px">
                                    <Tooltip portalContainer={document.body} content={"Weightage"} placement="top">
                                      <img
                                        src={Weightage}
                                        alt="weightage icon"
                                        style={{ width: 20, height: 20, marginRight: '5px', marginTop: '4px' }}
                                      />
                                    </Tooltip>
                                    <span className="weight-value  weight-value-fixed ">{goal.goal_weight}</span>
                                  </Flexbox>
                                  <Divider className="push-10-l push-10-r"></Divider>
                                  <Flexbox flexDirection="row" display="flex" alignItems="center" gap="8px">
                                    <Tooltip portalContainer={document.body} content={"Days left"} placement="top">
                                      <img
                                        src={TimeLeft}
                                        alt="time left icon"
                                        style={{ width: 20, height: 20, marginRight: '5px', marginTop: '5px' }}
                                      />
                                    </Tooltip>
                                    <span className="weight-title days-left-fixed "> {this.getDaysLeft(goal)}</span>
                                  </Flexbox>
                                  <Divider className="push-10-l push-10-r"></Divider>
                                  {goal?.file_url &&
                                    <>
                                      <Flexbox flexDirection="row" display="flex" alignItems="center" gap="8px">
                                        <Tooltip portalContainer={document.body} content={goal.file_name || "Attached File"} placement="top">
                                          <div>
                                            <a href={goal.file_url} target="_blank" rel="noopener noreferrer" style={{ color: "#106ba3", textDecoration: "underline", cursor: "pointer" }}>
                                              <Icon icon="paperclip" size={12} />
                                            </a>
                                          </div>
                                        </Tooltip>
                                      </Flexbox>
                                      <Divider className="push-10-l push-10-r"></Divider>
                                    </>
                                  }

                                  <Tooltip portalContainer={document.body} content={"Progress"} placement="top">
                                    <img
                                      src={Progress}
                                      alt="progress icon"
                                      style={{ width: 20, height: 20, marginRight: '5px', marginTop: '4px' }}
                                    />
                                  </Tooltip>
                                  <GoalProgressRow goal={goal} subGoals={subGoals} accountId={this.getActiveAccountId()} />
                                </Flexbox>

                              </Flexbox>

                              {/* Right Section: Status + Actions */}
                              <Flexbox flexDirection="row" alignItems="flex-start" className="goal-header-actions">
                                <div
                                  //className="push-10-l push-10-r"
                                  style={{
                                    border: `1px solid ${this.getStatusColor(goal.goal_progress_states)} `,
                                    borderRadius: "20px",
                                    padding: "6px 18px"
                                  }}
                                >
                                  <span style={{ fontWeight: "400", color: this.getStatusColor(goal.goal_progress_states) }}>{goal.goal_progress_states}</span>
                                </div>

                                {selectedTimeframe.is_editable && <Flexbox className="goal-item-actions" alignItems="center">
                                  <Tooltip content="Edit goal" placement="top" portalContainer={document.body}>
                                    <Button
                                      icon={<img src={EditIcon} style={{ width: 18, height: 18 }} />}
                                      minimal
                                      onClick={() => this.handleEditGoal(goal)}
                                      className="no-hover-btn"
                                    // style={{ paddingRight: "0px" }}
                                    />
                                  </Tooltip>
                                  <Tooltip content="Delete goal" placement="top" portalContainer={document.body}>
                                    <Button
                                      icon={
                                        <img src={Delete} style={{ width: 18, height: 18 }} />
                                      }
                                      minimal
                                      className="no-hover-btn"
                                      onClick={() => this.openDeleteGoalConfirmationDialog(goal)}
                                    />
                                  </Tooltip>
                                </Flexbox>}
                              </Flexbox>
                            </Flexbox>
                            <div style={{ display: "flex", gap: 10 }}>
                              <div style={{ marginLeft: 50, marginTop: 21 }}>
                                {selectedTimeframe.is_editable && (
                                  <FilledButton
                                    text={subGoalLoadingByGoalId?.[goal.id] ? "Adding..." : "+ Add sub-goal"}
                                    onClick={() => this.handleAddSubGoal(goal)}
                                    disabled={Boolean(subGoalLoadingByGoalId?.[goal.id])}
                                    style={{ fontSize: "13px", marginRight: "4px" }}
                                  />
                                )}
                              </div>

                              {/* SUB-GOAL TOGGLE + LIST */}
                              <div
                                style={{
                                  marginTop: "20px",
                                  fontSize: "15px",
                                  color: "#6f5bd7",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                onClick={() => {
                                  if (subGoals.length > 0) {
                                    this.setState(prev => ({
                                      openSubGoals: {
                                        ...prev.openSubGoals,
                                        [goal.id]: !prev.openSubGoals[goal.id]
                                      }
                                    }));
                                  }
                                }}
                              >
                                <Icon
                                  icon={this.state.openSubGoals[goal.id] ? "chevron-down" : "chevron-right"}
                                  size={14}
                                />
                                {subGoals.length} Sub-goals
                              </div>
                            </div>

                            <GoalCollapse isOpen={this.state.openSubGoals[goal.id]} keepChildrenMounted>
                              {subGoals.length > 0 && (
                                <div
                                  className={`subgoal-container ${this.state.openSubGoals[goal.id] ? "open" : ""
                                    }`}
                                  style={{ paddingLeft: "50px", marginTop: "10px" }}>
                                  {subGoals?.map(sub => (
                                    <Card
                                      key={sub.id}
                                      style={{
                                        marginBottom: "12px",
                                        borderRadius: "8px",
                                        border: "1px solid #E4E7EC",
                                        padding: "12px",
                                        boxShadow: "none"
                                      }}
                                    >
                                      <Flexbox flexDirection="row">
                                        <Flexbox>
                                          <div className="goal-icon-box">
                                            <img src={Subgoal} alt="subgoalIcon" />
                                          </div>
                                        </Flexbox>
                                        <Flexbox flexDirection="column" style={{ flex: 1, paddingLeft: "12px" }}>
                                          <Flexbox alignItems="center" gap="8px" style={{ marginBottom: "8px" }}>
                                            <span onClick={() => this.handleEditSubGoalOpen(goal, sub)} className="goal-title">
                                              {sub.title}
                                            </span>
                                            {sub?.user_comment && (
                                              <Tooltip portalContainer={document.body} content={sub?.user_comment} placement="top" popoverClassName="goal-description-tooltip">
                                                <div style={{ cursor: "pointer", marginTop: '5px' }}>
                                                  <img
                                                    src={Comment1}
                                                    alt="comment icon"
                                                    style={{ width: 20, height: 20, marginRight: '5px' }}
                                                  />
                                                </div>
                                              </Tooltip>
                                            )}
                                            {sub?.goal_comment && (
                                              <Tooltip portalContainer={document.body} content={sub?.goal_comment} placement="top" popoverClassName="goal-description-tooltip">
                                                <div style={{ cursor: "pointer", marginTop: '5px' }}>
                                                  <img
                                                    src={Comment2}
                                                    alt="comment icon"
                                                    style={{ width: 20, height: 20, marginRight: '5px' }}
                                                  />
                                                </div>
                                              </Tooltip>
                                            )}
                                            {sub?.description && (
                                              <Tooltip portalContainer={document.body} content={sub?.description} placement="top" popoverClassName="goal-description-tooltip">
                                                <div style={{ cursor: "pointer", marginTop: '5px' }}>
                                                  <img
                                                    src={DescriptionIcon}
                                                    alt="description icon"
                                                    style={{ width: 25, height: 20, marginRight: '5px' }}
                                                  />
                                                </div>
                                              </Tooltip>
                                            )}
                                          </Flexbox>
                                          {/* Description under title removed as per request */}
                                          <Flexbox flexDirection="row" gap="16px" alignItems="center">
                                            {sub?.file_url &&
                                              <>
                                                <Flexbox flexDirection="row" display="flex" alignItems="center" gap="8px">
                                                  <Tooltip portalContainer={document.body} content={sub?.file_name || "Attached File"} placement="top">
                                                    <div>
                                                      <a href={sub?.file_url} target="_blank" rel="noopener noreferrer" style={{ color: "#106ba3", textDecoration: "underline", cursor: "pointer" }}>
                                                        <Icon icon="paperclip" size={12} />
                                                      </a>
                                                    </div>
                                                  </Tooltip>
                                                  <Divider className="push-10-l push-10-r question-divider" style={{ height: "20px" }} ></Divider>

                                                </Flexbox>
                                              </>
                                            }
                                            <Tooltip portalContainer={document.body} content={"Progress"} placement="top">
                                              <img
                                                src={Progress}
                                                alt="progress icon"
                                                style={{ width: 20, height: 20, marginRight: '5px', marginTop: '4px' }}
                                              />
                                            </Tooltip>
                                            <GoalProgressRow goal={sub} accountId={this.getActiveAccountId()} />
                                          </Flexbox>
                                        </Flexbox>

                                        <Flexbox
                                          flexDirection="row"
                                          alignItems="flex-start"
                                          className="subgoal-header-actions"
                                        >
                                          {/* ACTION BUTTONS */}
                                          <Flexbox className="goal-item-actions">
                                            <Tooltip content="Edit sub-goal" placement="top" portalContainer={document.body}>
                                              <Button
                                                icon={<img src={EditIcon} style={{ width: 18, height: 18 }} />}
                                                minimal
                                                onClick={() => this.handleEditSubGoalOpen(goal, sub)}
                                                className="no-hover-btn"
                                              />
                                            </Tooltip>
                                            <Tooltip content="Delete sub-goal" placement="top" portalContainer={document.body}>
                                              <Button
                                                icon={<img src={Delete} style={{ width: 18, height: 18 }} />}
                                                minimal
                                                className="no-hover-btn"
                                                onClick={() => this.openDeleteSubGoalConfirmationDialog(goal, sub)}
                                              />
                                            </Tooltip>
                                          </Flexbox>

                                        </Flexbox>
                                      </Flexbox>
                                      <MilestoneList
                                        key={`${this.getEffectiveUserId()}:${selectedTimeframe.id}:${sub.id}`}
                                        subGoal={sub}
                                        goalSettingId={goal.goal_setting_id || selectedTimeframe.id}
                                        userId={this.getEffectiveUserId()}
                                        editable={Boolean(selectedTimeframe.is_editable)}
                                        onRefresh={() => this.fetchGoalsForSelectedCycle(false)}
                                      />
                                    </Card>
                                  ))}
                                </div>
                              )}
                            </GoalCollapse>
                          </Card>
                        );
                      })}

                    </>
                  ) : (
                    <div className="push-30-t">
                      <BlankPage
                        title={"No Goals Yet"}
                        description={`You haven't set any goals. Create your first goal to track your progress and stay on top of your priorities.`}
                      />
                    </div>
                  )}
                </div>

                <ConfirmationDialog
                  isOpen={this.state.showDeleteDialog}
                  onClose={this.handleCloseDeleteDialog}
                  onConfirm={this.handleConfirmDelete}
                  title="Delete Confirmation"
                  message="Are you sure you want to delete "
                  itemName={
                    this.state.deleteTarget?.type === "goal"
                      ? this.state.deleteTarget.goal?.title
                      : this.state.deleteTarget?.sub?.title
                  }
                  confirmext="Delete"
                  confirmITntent="danger"
                  isSubmitting={this.state.isDeleteSubmitting}
                />
              </Flexbox>

              <ConfirmationDialog
                isOpen={cascadeSelection.showConfirmation}
                onClose={this.handleCancelCascadeSelection}
                onConfirm={this.handleConfirmCascadeSelection}
                title="Confirm Cascading Goal Selection"
                message="This will add goal to the cascading goal and all its subgoals will be removed. Want to add"
                itemName={cascadeSelection.pending?.title || ""}
                confirmText="Confirm"
                confirmIntent="primary"
              />

              <ConfirmationDialog
                isOpen={openCascadingGoalDeleteDialog}
                onClose={() => this.handleCloseDeleteCascadingGoalConfirmationDialog()}
                onConfirm={() => this.handleConfirmDeleteCascadingGoal()}
                title="Delete Confirmation"
                message="Are you sure you want to delete this cascading goal "
                itemName={deletingCascadingGoal?.title || ""}
                confirmText="Delete"
                confirmIntent="danger"
              />
              <Drawer
                portalContainer={document.body}
                size={"40%"}
                isOpen={this.state.openCascadingGoalEditDrawer}
                onClose={() => this.setState({ openCascadingGoalEditDrawer: false })}
                className="goal-edit-drawer"
                title="Update Cascading Goal"
              >
                <div className="goal-edit-drawer-content">
                  <Flexbox flexDirection="row" flexGrow={1} padding="20px" style={{ marginLeft: "0px" }}>
                    <Flexbox flexDirection="column" flexGrow={1} className="bp3-form-content">
                      <FormGroup className="input-label push-10-b push-10-t" label="Cascading Goal Title" labelFor="">
                        <input
                          placeholder="Title"
                          className="bp3-input bp3-control-no-margin push-10-b"
                          type="text"

                          value={editingCascadingGoal.title || ""}
                          onChange={e =>
                            this.handleCascadeFieldChange("title", e.target.value)
                          }
                          style={{ border: "1px solid #e1e1e1", boxShadow: "none", height: "38px", width: "100%" }}
                          disabled={!selectedTimeframe.is_editable}
                        />
                      </FormGroup>
                      <FormGroup className="input-label push-10-b push-10-t" label="Cascading Goal Description" labelFor="">
                        <TextArea
                          name="description"
                          placeholder="Description"
                          rows={5}
                          value={editingCascadingGoal.description || ""}
                          onChange={e =>
                            this.handleCascadeFieldChange("description", e.target.value)
                          }
                          className="push-10-t push-10-b"
                          style={{ resize: "none", border: "1px solid #e1e1e1", boxShadow: "none", width: "100%" }}
                          disabled={!selectedTimeframe.is_editable}
                        />
                      </FormGroup>
                    </Flexbox>
                  </Flexbox>

                  <Flexbox flexDirection="row" flexGrow={1} padding="20px">
                    <FilledButton
                      disabled={isSavingCascadingGoal}
                      onClick={this.handleSubmitCascadingGoal}
                      style={{ marginRight: "10px", display: "inline-flex", alignItems: "center", gap: "8px" }}
                    >
                      {isSavingCascadingGoal && <Icon icon="smile" size={14} style={{ color: "#fff" }} />}
                      <span>{isSavingCascadingGoal ? "Updating..." : "Update"}</span>
                    </FilledButton>
                    <OutlinedButton text="Cancel" onClick={() => this.handleCancelCascadingGoal()} />
                  </Flexbox>

                </div>
              </Drawer>

              <Drawer
                portalContainer={document.body}
                size={"40%"}
                isOpen={isDrawerOpen}
                onClose={this.handleCancelGoal}
                // onClose={() => this.setState({ isDrawerOpen: false })}
                className="goal-edit-drawer"
                title={this.state.editingType === "subgoal"
                  ? "Update Sub Goal"
                  : "Update Goal"}
                transitionDuration={5000}
              >
                {editingGoal && (
                  <div className="goal-edit-drawer-content">
                    <Flexbox flexDirection="row" flexGrow={1} padding="20px">
                      <Flexbox flexDirection="column" flexGrow={1} className="bp3-form-content">
                        <FormGroup className="edit-label push-10-b push-10-t" label={editingType === "goal" ? "Goal Title" : "Subgoal Title"} labelFor="">
                          <input
                            placeholder="Title"
                            className="bp3-input bp3-control-no-margin push-10-b"
                            type="text"
                            name="title"
                            // value={editedGoals[editingGoal.id]?.title || ""}
                            value={editingGoal.title}
                            onChange={e => this.handleGoalInputChange(editingGoal.id, "title", e.target.value)}
                            style={{ border: "1px solid #e1e1e1", boxShadow: "none", height: "38px", width: "100%" }}
                            disabled={!selectedTimeframe.is_editable}
                          />
                        </FormGroup>

                        <FormGroup label={editingType === "goal" ? "Goal Description" : "Subgoal Description"} className="edit-label">
                          <TextArea
                            name="description"
                            placeholder="Description"
                            rows={5}
                            value={editingGoal.description}
                            onChange={e => this.handleGoalInputChange(editingGoal.id, "description", e.target.value)}
                            className=" push-10-b"
                            style={{ resize: "none", border: "1px solid #e1e1e1", boxShadow: "none", width: "100%" }}
                            disabled={!selectedTimeframe.is_editable}
                          />
                        </FormGroup>


                        <div style={{ display: "flex", gap: "86px", width: "100%" }}>
                          {!hasSubGoals && (
                            <FormGroup
                              className="edit-label"
                              label="Progress metric type"
                              style={{
                                flex: editingGoal.progress_type === "stage_wise" ? 1 : "0 0 37%",
                                maxWidth: "350px"
                              }}
                            >
                              <HTMLSelect
                                fill
                                value={editingGoal.progress_type || "percentage"}
                                onChange={e =>
                                  this.handleGoalInputChange(
                                    editingGoal.id,
                                    "progress_type",
                                    e.target.value
                                  )
                                }
                                options={[
                                  { label: "Percentage", value: "percentage" },
                                  { label: "Stage", value: "stage_wise" },
                                  { label: "Number", value: "number" }
                                ]}
                                disabled={!selectedTimeframe.is_editable}
                              />
                            </FormGroup>
                          )}

                          {/* Show Range (Min – Max) next to Progress metric type when 'number' is selected */}
                          {!hasSubGoals && editingGoal.progress_type === "number" && (
                            <FormGroup
                              className="edit-label"
                              label="Range (Min – Max)"
                              style={{
                                flex: editingGoal.progress_type === "stage_wise" ? 1 : "0 0 37%",
                                maxWidth: "350px"
                              }}
                            >
                              <div style={{ display: "flex", alignItems: "center", gap: "23px", marginBottom: "14px" }}>
                                <NumericInput
                                  min={0}
                                  buttonPosition="none"
                                  clampValueOnBlur={false}
                                  allowNumericCharactersOnly
                                  value={editingGoal.minValue ?? 0}
                                  onValueChange={(val) => {
                                    let safe = Math.floor(val || 0);
                                    this.setState(prev => ({
                                      editingGoal: { ...prev.editingGoal, minValue: safe }
                                    }));
                                  }}
                                  onBlur={(e) => {
                                    const val = Number(e.target.value);
                                    let safe = val < 0 ? 0 : val;
                                    let newMax = editingGoal.maxValue;
                                    if (safe > (editingGoal.maxValue ?? Infinity)) {
                                      newMax = safe;
                                    }
                                    this.setState(prev => ({
                                      editingGoal: { ...prev.editingGoal, minValue: safe, maxValue: newMax }
                                    }));
                                  }}
                                  placeholder="Min"
                                  style={{ width: "150px" }}
                                />
                                <span style={{ color: "#5c7080" }}>to</span>
                                <NumericInput
                                  min={0}
                                  buttonPosition="none"
                                  clampValueOnBlur={false}
                                  allowNumericCharactersOnly
                                  value={editingGoal.maxValue ?? 0}
                                  onValueChange={(val) => {
                                    let safe = Math.floor(val || 0);
                                    this.setState(prev => ({
                                      editingGoal: { ...prev.editingGoal, maxValue: safe }
                                    }));
                                  }}
                                  onBlur={(e) => {
                                    const val = Number(e.target.value);
                                    let safe = val;
                                    let newMin = editingGoal.minValue;
                                    if (safe < (editingGoal.minValue ?? 0)) {
                                      newMin = safe;
                                    }
                                    this.setState(prev => ({
                                      editingGoal: { ...prev.editingGoal, maxValue: safe, minValue: newMin }
                                    }));
                                  }}
                                  placeholder="Max"
                                  style={{ width: "150px" }}
                                />
                              </div>
                            </FormGroup>
                          )}

                          {!hasSubGoals && editingGoal.progress_type === "stage_wise" && (
                            <FormGroup
                              className="edit-label"
                              label="Matrics value"
                              style={{ flex: 1, minWidth: "250px" }}
                            >
                              <HTMLSelect
                                fill
                                value={String(editingGoal.metric_value ?? "0")}
                                onChange={e => {
                                  const value = Number(e.target.value);
                                  const progressMap = { 0: 0, 1: 0, 2: 0, 3: 50, 4: 100 };
                                  this.setState(prev => ({
                                    editingGoal: {
                                      ...prev.editingGoal,
                                      metric_value: value,
                                      progress: progressMap[value]
                                    }
                                  }));
                                }}
                                options={[
                                  { label: "Not Started", value: "0" },
                                  { label: "On Hold", value: "1" },
                                  { label: "Not Completed", value: "2" },
                                  { label: "In Progress", value: "3" },
                                  { label: "Completed", value: "4" },
                                ]}
                              />
                            </FormGroup>
                          )}
                        </div>

                        {!hasSubGoals && editingGoal.progress_type === "percentage" && (
                          <FormGroup className="edit-label " label="Progress">
                            <Slider
                              labelStepSize={10}
                              min={0}
                              max={this.getProgressMax()}
                              value={editingGoal.progress || 0}
                              className="push-10-l"
                              onChange={value =>
                                this.setState(prev => ({
                                  editingGoal: {
                                    ...prev.editingGoal,
                                    progress: value
                                  }
                                }))
                              }
                            />
                          </FormGroup>
                        )}

                        {!hasSubGoals && editingGoal.progress_type === "number" && (
                          <FormGroup className="edit-label">
                            {/* PROGRESS LABEL */}
                            <div style={{ marginBottom: "6px" }}>
                              Current Progress
                            </div>

                            {/* PROGRESS INPUT */}
                            <NumericInput
                              min={0}
                              buttonPosition="none"
                              clampValueOnBlur={false}
                              allowNumericCharactersOnly
                              value={editingGoal.progress ?? 0}
                              onValueChange={(val) => {
                                let safe = Math.floor(val || 0);
                                const max = editingGoal.maxValue ?? Infinity;
                                if (safe > max) {
                                  safe = max;
                                }

                                this.setState(prev => ({
                                  editingGoal: {
                                    ...prev.editingGoal,
                                    progress: safe
                                  }
                                }));
                              }}
                              onBlur={(e) => {
                                const val = Number(e.target.value);
                                let safe = val;
                                const min = editingGoal.minValue ?? 0;
                                const max = editingGoal.maxValue ?? Infinity;
                                if (safe < min) {
                                  ToastStore.showToast("Progress cannot be less than Min value", "warning");
                                  safe = min;
                                } else if (safe > max) {
                                  ToastStore.showToast("Progress cannot be greater than Max value", "warning");
                                  safe = max;
                                }
                                this.setState(prev => ({
                                  editingGoal: { ...prev.editingGoal, progress: safe }
                                }));
                              }}
                              placeholder="Enter progress"
                              style={{ width: "200px" }}
                            />
                          </FormGroup>
                        )}

                        {hasSubGoals && (
                          <div style={{ color: "#d9822b", fontSize: "14px", marginTop: "10px", marginBottom: "10px" }}>
                            Goal progress is auto calculated from sub-goals.
                          </div>
                        )}

                        {/* Add file */}
                        <FormGroup label="Attachments" className="edit-label push-10-b push-10-t">
                          {!editingGoal.file_name && (
                            <>
                              <label htmlFor={`file-${editingGoal.id}`} className="goal-upload-box">
                                <div className="upload-icon">
                                  <Icon icon="upload" size={16} />
                                </div>

                                <div>
                                  <div className="upload-title">Add file</div>
                                  <div className="upload-subtitle">Click to upload or drag & drop</div>
                                </div>

                                <input
                                  id={`file-${editingGoal.id}`}
                                  type="file"
                                  style={{ display: "none" }}
                                  onChange={(e) => {
                                    const file = e.target.files[0];
                                    this.handleFileUpload(editingGoal.id, file);
                                  }}
                                />
                              </label>

                              <input
                                id={editingGoal.id}
                                type="file"
                                style={{ display: "none" }}
                                onChange={(e) => {
                                  const file = e.target.files[0];
                                  this.handleFileUpload(editingGoal.id, file);
                                }}
                              />
                            </>
                          )}

                          {editingGoal.file_name && (
                            <div
                              style={{
                                marginTop: 8,
                                display: "inline-flex",
                                alignItems: "center",
                                background: "#f5f8fa",
                                border: "1px solid #d8e1e8",
                                borderRadius: 6,
                                padding: "6px 10px",
                                fontSize: 13,
                                gap: 8
                              }}
                            >
                              {editingGoal.file_url ? (
                                <a
                                  href={editingGoal.file_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: "#106ba3", textDecoration: "none" }}
                                >
                                  📄 {editingGoal.file_name}
                                </a>
                              ) : (
                                <span>📄 {editingGoal.file_name}</span>
                              )}

                              <span
                                style={{
                                  cursor: "pointer",
                                  color: "#d14343",
                                  fontWeight: "bold",
                                  fontSize: 14
                                }}
                                onClick={() =>
                                  this.setState(prev => ({
                                    editingGoal: {
                                      ...prev.editingGoal,
                                      file: null,
                                      file_name: null
                                    }
                                  }))
                                }
                              >
                                ✕
                              </span>
                            </div>
                          )}

                        </FormGroup>

                        {this.state.editingType === "goal" &&
                          <FormGroup label="Cascading Goal" className="edit-label push-10-b push-10-t">
                            <p className="edit-label-description">Select a cascading goal to link this goal to it. After saving, the goal will be added to the selected cascading goal’s linked goals.</p>
                            <ScrollableDropdown
                              width={250}
                              //   label={editingGoal.cascade_id ? editingGoal.cascade_id : "Select a cascading goal"}
                              label={cascadeSelection.selected ? cascadeSelection.selected.title : "Select a cascading goal"}
                              // label={selectedCascadingGoal ? selectedCascadingGoal.title : "Select a cascading goal"}
                              items={cascadingSelectionList}
                              getKey={g => g.id}
                              getLabel={g => g.title}
                              enableSearch={true}
                              onSelect={item => this.handleCascadeSelection(item)}
                            />
                          </FormGroup>}

                        <FormGroup label={editingType === "goal" ? "Goal End Date" : "Subgoal End Date"} className="edit-label max-width push-10-b push-10-t">
                          <div className="flex flex-row">
                            <input
                              type="date"
                              value={editingGoal.goal_end_at ? moment.utc(editingGoal.goal_end_at).format("YYYY-MM-DD") : moment.utc(selectedTimeframe.end_date).format("YYYY-MM-DD")}
                              onChange={(e) =>
                                this.handleGoalInputChange(editingGoal.id, "goal_end_at", e.target.value)
                              }
                              placeholder="End Date"
                              className={`${Classes.INPUT}`}
                            />
                          </div>
                        </FormGroup>

                        {this.state.editingType === "goal" && (
                          <>
                            {editingGoal?.is_weight_allow && (
                              <FormGroup label="Goal Weightage" className="edit-label push-10-b push-10-t">
                                <NumericInput
                                  allowNumericCharactersOnly={true}
                                  name="goal_weight"
                                  placeholder="Weight"
                                  min={0}
                                  max={100}
                                  value={editingGoal.goal_weight || 0}
                                  onValueChange={value =>
                                    this.handleGoalInputChange(editingGoal.id, "goal_weight", value)
                                  }
                                  disabled={!selectedTimeframe.is_editable}
                                  style={{ height: "34px", width: "100px" }}
                                />
                              </FormGroup>
                            )}

                            <FormGroup label="Progress Status" className="edit-label push-10-b push-10-t" style={{ width: '40%' }}>
                              <Flexbox flexDirection="row" alignItems="center" gap="10px">
                                <span style={{ fontWeight: 500, color: "#555" }}>
                                  {formatGoalProgressPercent(editingGoal)}
                                </span>
                                <GoalProgressStatusBadge goal={editingGoal} style={{ marginLeft: 10 }} />
                              </Flexbox>
                            </FormGroup>
                          </>
                        )}

                        {this.state.editingType === "goal" && (
                          <FormGroup className="edit-label push-10-t" label="Comment" labelFor="">
                            <TextArea
                              name="user_comment"
                              placeholder="Comment"
                              rows={5}
                              value={editingGoal.user_comment}
                              onChange={e => this.handleGoalInputChange(editingGoal.id, "user_comment", e.target.value)}
                              className="push-10-b"
                              style={{ resize: "none", border: "1px solid #e1e1e1", boxShadow: "none", width: "100%" }}
                              disabled={!selectedTimeframe.is_editable}
                            />
                          </FormGroup>
                        )}

                        {!selectedTimeframe.is_editable && (
                          <div className="editable-warning-box">
                            <p className="editable-warning-title">Your goal has been published and locked</p>
                            <p className="editable-warning-description">
                              You can no longer edit the goal details. Only progress updates are allowed at this stage. If you need to request
                              changes, please contact your HR team or manager.
                            </p>
                          </div>
                        )}

                        <div style={{ marginTop: "10px", display: "flex", alignItems: "center" }}>
                          <FilledButton
                            disabled={isSavingGoal}
                            onClick={() => this.handleSubmit(editingGoal.id)}
                            text="Save"
                          />
                          <TextButton text="Cancel" onClick={this.handleCancelGoal} />
                          {isSavingGoal && <img src="https://s01.live2support.com/dashboardv2/chatassets/img/loader_new.gif" width={35} height={35} alt="Saving..." role="status" />}
                        </div>
                      </Flexbox>
                    </Flexbox>
                  </div>
                )}
              </Drawer>
            </Flexbox>
          </ErrorBoundary>
        </ThemeWrapper>
      </Provider>
    );
  }
}
